<template>
    <div class="home-container">
        <div class="logo">
            <van-image
                    width="96px"
                    height="96px"
                    fit="fit"
                    :src="icon"/>

            <div class="title-container">
                <span class="title">Bluetooth Connector</span>
                <span class="subtitle">Connect to a Bluetooth Device</span>
            </div>
        </div>


        <div class="filter-group">
            <span>Scan parameters</span>
            <van-radio-group v-model="filterType">
                <van-radio name="1" class="filter-item">All devices</van-radio>
                <van-radio name="2" class="filter-item">Filtered devices</van-radio>
            </van-radio-group>
        </div>


        <div class="filter-name-config" v-if="!isAcceptAllDevices">
            <span>Device Name, ie: "Fake Heart Rate"</span>
            <van-cell-group class="filter-device-name">
                <van-field v-model="filterDeviceName" placeholder="Device name..."/>
            </van-cell-group>
        </div>


        <div class="filter-name-config" v-if="!isAcceptAllDevices">
            <span>Device Name Prefix, ie: "Fake"</span>
            <van-cell-group class="filter-device-name">
                <van-field v-model="prefixDeviceName" :border="true" :clearable="true"
                           placeholder="Device name Prefix..."/>
            </van-cell-group>
        </div>


        <div class="filter-name-config" v-if="!isAcceptAllDevices">
            <span>Service filter, ie: "BATTERY_SERVICE"</span>
            <van-cell-group class="filter-device-name">
                <van-field
                        readonly
                        clickable
                        :value="filterService"
                        placeholder="click to select service"
                        @click="showPicker = true"/>

                <van-popup v-model="showPicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="servicesOptions"
                            @cancel="showPicker = false"
                            @confirm="onConfirm"/>
                </van-popup>
            </van-cell-group>
        </div>

        <div class="scan-button" @click="scanDevice">Scan Device</div>

    </div>
</template>

<script>
    import Constant from "../constant/config"
    import bluetoothRepository from "../repository/BluetoothRepository"

    export default {
        name    : 'Home',
        data() {
            return {
                icon            : require("../assets/icon.png"),
                filterType      : '1',
                filterDeviceName: '',
                prefixDeviceName: ' ',
                filterService   : '',
                showPicker      : false,
                filterOptions   : {}
            }
        },
        methods : {
            onConfirm(value, index) {
                this.filterService             = value
                this.filterOptions.serviceUUID = Constant.DEFAULT_SERVICE[index].uuid
                this.showPicker                = false;
            },
            scanDevice() {
                const filter = {}

                filter.acceptAllDevices = this.isAcceptAllDevices

                if (!this.isAcceptAllDevices) {
                    filter.filterCondition = {
                        filterDeviceName: this.filterDeviceName,
                        prefixDeviceName: this.prefixDeviceName,
                        filterService   : this.filterOptions.serviceUUID
                    }
                }

                bluetoothRepository.scanDevice(filter)
                    .then(data => {

                    })
            }
        },
        computed: {
            servicesOptions() {
                let serviceOptions = []
                Constant.DEFAULT_SERVICE.map(item => serviceOptions.push(`${item.serviceName} (0x${item.uuid.toString(16)})`))
                return serviceOptions
            },
            isAcceptAllDevices() {
                return this.filterType === '1'
            }
        },
        mounted() {
            // console.log("1231231")
        }
    }
</script>


<style lang="scss" scoped>
    .home-container {
        display: flex;
        padding: 16px;
        flex-direction: column;

        .logo {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-items: center;

            .title-container {
                margin-left: 1rem;
                flex-direction: column;
                justify-items: start;
                display: flex;
                color: #000;

                .title {
                    padding: 10px 0;
                    font: 18px bold;
                }

                .subtitle {
                    padding: 10px 0;
                    font-size: 10px;
                }
            }
        }

        .filter-group {
            display: flex;
            margin-top: 16px;
            flex-direction: column;
            justify-items: flex-start;

            .filter-item {
                margin-top: 20px;
            }
        }

        .filter-name-config {
            display: flex;
            margin-top: 32px;
            flex-direction: column;

            .filter-device-name {
                margin-top: 10px;
                border: 1px solid #999;
            }
        }

        .filter-service-config {

            display: flex;
            margin-top: 16px;
            flex-direction: column;
        }

        .scan-button {
            background-color: black;
            text-align: center;
            font-size: 18px;
            margin: 16px 0;
            padding: 16px 0;
            color: white;
        }
    }
</style>
